import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import saveStreamExcel from '../../../infra/helper/saveStreamEXCEL'

export default (jobid,status, type, fileName) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    var body = {"jobid":jobid,
                "status":status};

    const Authorization = UserToken;
    const url = ApiUrl2 + 'download-uploadfile';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : JSON.stringify(body)
    };

    const response = await doFetch(url,argument);
    if(response.ok){
        var responseText = await response.text();
        saveStreamExcel(fileName, responseText)
    }
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};